import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { KTSVG } from '../../../_metronic/helpers'
//import {CampaignParticipantFormModal} from './_modals/CampaignParticipantFormModal'
import { CampaignParticipantListModal } from './_modals/CampaignParticipantListModal'
import { DeleteModal } from '../../components/modals/DeleteModal'
import CampaignParticipantApi from '../../../infrastructure/api/CampaignParticipantApi'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../setup'
import { UserModel } from '../../modules/auth/models/UserModel'
const CampaignParticipantPage: FC = () => {
  const [itemId, setItemId] = useState(0)
  const [itemName, setItemName] = useState('')
  const [showDelete, setShowDelete] = useState(false)
  const handleCloseDelete = () => setShowDelete(false)
  const handleShowDelete = () => setShowDelete(true)

  const [refresh, setRefresh] = useState<number>(0)
  const [showForm, setShowForm] = useState(false)
  const handleCloseForm = () => { setShowForm(false); setRefresh(refresh + 1) }
  const handleShowForm = () => setShowForm(true)

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const onClickItem = (value: number, name: string, type: string) => {
    setItemId(value)
    setItemName(name)
    switch (type) {
      case 'delete':
        handleShowDelete()
        break
      default:
        handleShowForm()
        break
    }
  }

  async function deleteCampaignParticipant(itemId: number) {
    var response = await CampaignParticipantApi.DeleteCampaignParticipant(itemId)
    setRefresh(refresh + 1)
  }

  return (
    <>
      <div className='card mb-5 mb-xl-8'>
        <div className='card-body py-3'>
          <CampaignParticipantListModal refresh={refresh} onClickItem={onClickItem} />
          {/* <CampaignParticipantFormModal itemId={itemId} show={showForm} handleClose={handleCloseForm} /> */}
          <DeleteModal
            itemId={itemId}
            itemName={itemName}
            handleClose={handleCloseDelete}
            show={showDelete}
            type='Campaign Participant'
            confirm={deleteCampaignParticipant}
          />
        </div>
      </div>
    </>
  )
}

const CampaignParticipantWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>Campaign</PageTitle>
      <CampaignParticipantPage />
    </>
  )
}

export { CampaignParticipantWrapper }
